import React, { useEffect, useRef } from "react";
import Style from "../styles/navbar.module.scss";
import { HiMenuAlt2 } from "react-icons/hi";
import { useSelector, useDispatch } from "react-redux";
import { toggle, dropdown, setAdminLogout } from "../redux/index";
import { useNavigate } from "react-router-dom";
import  { adminRoutes } from "../routers/AdminRouters";
import Dashboard_Icon from "../assets/dashboard/Menu/Dashboard.png";
import Exercises_Icon from "../assets/dashboard/Menu/Exercises.png";
import Gym_Icon from "../assets/dashboard/Menu/Gym-management.png";
import Session_Icon from "../assets/dashboard/Menu/Sessions.png";
import Logo_Icon from "../assets/auth/logo.png";
import Logout_Icon from "../assets/dashboard/Menu/logout.png";
import { IoIosArrowDown } from "react-icons/io";
import Resetpassimg from "../assets/dashboard/Menu/reset_password.png";

const Navbar = () => {
  const isbutton = useSelector((state) => state.navbar.button);
  const issidebar = useSelector((state) => state.navbar.sidemenu);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const arrowRef = useRef(null);
  const containerRef = useRef(null);

  const handleLogout = async () => {
    dispatch(setAdminLogout());
    navigate(adminRoutes.login);
  };

  useEffect(() => {
    const handleClick = (event) => {
      if (
        containerRef.current &&
        containerRef.current.contains(event.target) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        arrowRef.current &&
        !arrowRef.current.contains(event.target)
      ) {
        if (issidebar) {
          dispatch(dropdown());
        }
      }
    };

    containerRef.current?.addEventListener("click", handleClick);

    return () => {
      containerRef.current?.removeEventListener("click", handleClick);
    };
  }, [issidebar, dispatch]);

  const dashboard = () => {
    navigate(adminRoutes.dashboard);
    dispatch(toggle());
  };

  const allsession = () => {
    navigate(adminRoutes.listSession);
    dispatch(toggle());
  };

  // const schedulesession = () => {
  //   navigate(adminRoutes.listSession);
  //   dispatch(toggle());
  // };

  const exercise = () => {
    navigate(adminRoutes.listExercise);
    dispatch(toggle());
  };

  const gymmanagement = () => {
    navigate(adminRoutes.listGym);
    dispatch(toggle());
  };

  const handleChangePassword = () => {
    navigate(adminRoutes.resetPassword);
  };
  return (
    <div className={Style.navbarmaincontainer} ref={containerRef}>
      <nav className={Style.navbar}>
        <div className={Style.navbar_left}>
          <button
            className={Style.hamburger_icon}
            onClick={() => dispatch(toggle())}
          >
            {isbutton ? <HiMenuAlt2 /> : <HiMenuAlt2 />}
          </button>

          <div className={Style.logo}>
            <img src={Logo_Icon} />
          </div>
        </div>
        <div className={Style.navbar_right}>
          <div className={Style.user_info}>
            <div className={Style.user_logo}></div>

            <div className={Style.user_data}>
              <div className={Style.user_name}>
                <h1>The Training Room </h1>
                <p>Administrator</p>
              </div>

              <div
                ref={arrowRef}
                onClick={() => dispatch(dropdown())}
                className={Style.userarrowdown}
              >
                <IoIosArrowDown />
              </div>

              {issidebar ? (
                <div
                  ref={dropdownRef}
                  className={Style.dropdown_password}
                  onClick={handleChangePassword}
                >
                  <div className={Style.dropdown_password_img}>
                    <img src={Resetpassimg} />
                  </div>
                  <div className={Style.dropdown_password_text}>
                    <h2>Change Password</h2>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </nav>

      {/* Sidebar */}
      <div className={`${Style.sidebar} ${isbutton ? Style.open : ""}`}>
        <ul className={Style.menu}>
          <li onClick={dashboard} className={Style.menu_item}>
            <div className={Style.menu_item_main}>
              <a>
                <img src={Dashboard_Icon} />
                <span>Dashboard</span>
              </a>
            </div>
          </li>

          {/* <li >Dashboard</li> */}

          <li onClick={allsession} className={Style.menu_item}>
            <div className={Style.menu_item_main}>
              <a>
                <img src={Session_Icon} />
                <span> Sessions</span>
              </a>
            </div>{" "}
          </li>

          {/* <li className={Style.menu_item}>
            <div className={Style.menu_item_main}>
              <a onClick={() => dispatch(dropdown())}>
                <img src={Session_Icon} />
                <span>
                  Sessions{" "}
                  <strong>
                    <IoIosArrowForward />
                  </strong>
                </span>
              </a>
            
             
             
              <ul className={`${Style.submenu} ${issidebar ? Style.open : ""}`}>
                <li onClick={allsession} className={Style.menu_item}>
                  {" "}
                  <a className={Style.submenu_anchor}>ALL SESSIONS</a>
                </li>

                <li onClick={schedulesession} className={Style.menu_item}>
                  {" "}
                  <a className={Style.submenu_anchor}>SCHEDULE SESSIONS</a>
                </li>
              </ul>
            </div>
          </li> */}

          <li onClick={exercise} className={Style.menu_item}>
            <div className={Style.menu_item_main}>
              <a>
                <img src={Exercises_Icon} />
                <span> Exercises</span>
              </a>
            </div>{" "}
          </li>

          <li onClick={gymmanagement} className={Style.menu_item}>
            <div className={Style.menu_item_main}>
              <a>
                <img src={Gym_Icon} />
                <span> Gym management</span>
              </a>
            </div>{" "}
          </li>
        </ul>

        <div className={Style.logout}>
          <button className={Style.logout_button} onClick={handleLogout}>
            <span>
              <img src={Logout_Icon} /> Logout
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
